import React from "react";
import { useDropzone } from "react-dropzone";

export const FileUploadBox = () => {
	const { getRootProps, getInputProps } = useDropzone();

	return (
		<div
			{...getRootProps()}
			className="w-full flex items-center justify-center py-2 px-4 mb-4 border-2 border-dotted border-border text-gray-300 cursor-pointer hover:bg-secondary hover:text-secondary-foreground rounded-lg border-spacing-2 min-h-[150px]"
		>
			<input {...getInputProps()} />
			<span style={{ fontFamily: "monospace" }}>Upload a zip to start!</span>
		</div>
	);
};
